<script>
import { RepairFile } from '@/models/RepairFile'
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'
import SubStepProspectInformationClient from '@/views/restricted/repair-file-module/folder-setup/steps/prospect-folder/SubStepProspectInformationClient.vue'
import SubStepProspectRequest from '@/views/restricted/repair-file-module/folder-setup/steps/prospect-folder/SubStepProspectRequest.vue'
import SubStepProspectResponse from '@/views/restricted/repair-file-module/folder-setup/steps/prospect-folder/SubStepProspectResponse.vue'
import { displayToast } from '@/components/utils/globalFunction'

export default {
  name: 'StepCreateProspectFolder',
  components: { SubStepProspectResponse, SubStepProspectRequest, SubStepProspectInformationClient },
  computed: {
    RepairFileStatusDetailConstant() {
      return RepairFileStatusDetailConstant
    }
  },
  props: {
    currentRepairFile: RepairFile,
    currentStep: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    goToTransportStep() {
      this.$emit('refresh-repair-file')
      this.$emit('change-step', this.currentStep + 1)
    },
    async updatePartialData() {
      if (this.currentRepairFile) {
        if (
          this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.INTERNAL_COMMAND_NUMBER_LINKED
        ) {
          await this.$refs.subStepProspectInformationClient.updatePartialData()
        } else if (
          this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.PROSPECT_CLIENT_INFORMATION_RETRIEVED
        ) {
          await this.$refs.subStepProspectRequest.updatePartialData()
        } else if (
          this.currentRepairFile.status_detail ===
            RepairFileStatusDetailConstant.PROSPECT_REQUEST_SENT ||
          this.currentRepairFile.status_detail ===
            RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE
        ) {
          await this.$refs.subStepProspectResponse.updatePartialData()
        } else {
          displayToast(this.$t('ERROR.UNEXPECTED_ERROR_KEY'), 'error')
        }
      }
    },
    async handleProspectSubStepChange() {
      this.$emit('refresh-repair-file')
    },
    async handleProspectRefreshRepairFile() {
      this.$emit('refresh-repair-file')
    },
    async handleSaveAndCloseRepairFile() {
      this.$router.push({ name: 'Dashboard', query: { skip: 'true' } })
    },
    prospectClientInformationRetrieved() {
      return (
        this.currentRepairFile.status_detail !== RepairFileStatusDetailConstant.PRICING_EVALUATED &&
        (this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.PROSPECT_CLIENT_INFORMATION_RETRIEVED ||
          this.currentRepairFile.status_detail ===
            RepairFileStatusDetailConstant.PROSPECT_REQUEST_SENT ||
          this.currentRepairFile.status_detail ===
            RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE ||
          this.currentRepairFile.status_detail ===
            RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE_VALIDATED)
      )
    },
    prospectRequestSent() {
      return (
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.PROSPECT_REQUEST_SENT ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE_VALIDATED
      )
    },
    prospectResponseValidated() {
      return (
        this.currentRepairFile.status_detail ===
        RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE_VALIDATED
      )
    }
  }
}
</script>

<template>
  <!--File information-->
  <v-card class="rounded-xl mt-4 d-flex-column" :border="false" :elevation="0">
    <v-row>
      <v-col class="pb-0">
        <h1>{{ $t('STEP_PROSPECT.TITLE') }}</h1>
      </v-col>
    </v-row>

    <!--SUB_STEP_INFORMATION_CLIENT-->
    <v-row>
      <v-col class="pb-0">
        <h1 class="information-content-title mb-2 d-flex justify-space-between">
          {{ $t('STEP_PROSPECT.SUB_STEP_INFORMATION_CLIENT.TITLE') }}
          <img
            v-if="prospectClientInformationRetrieved()"
            alt="dialog-icon"
            class="svg-check-rounded"
            src="@/assets/icons/file/check_round.svg"
          />
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <SubStepProspectInformationClient
          v-if="!prospectClientInformationRetrieved()"
          :current-repair-file-props="currentRepairFile"
          ref="subStepProspectInformationClient"
          @change-prospect-sub-step="handleProspectSubStepChange"
        />
      </v-col>
    </v-row>
    <!--END SUB_STEP_INFORMATION_CLIENT-->

    <!--SUB_STEP_PROSPECT_REQUEST-->
    <div v-if="prospectClientInformationRetrieved()">
      <v-divider class="mt-2" :thickness="2" />
      <v-row>
        <v-col class="pb-0">
          <h1 class="information-content-title mb-2 d-flex justify-space-between">
            {{ $t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.TITLE') }}
            <img
              v-if="prospectRequestSent()"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <SubStepProspectRequest
            v-if="!prospectRequestSent()"
            :currentRepairFile="currentRepairFile"
            ref="subStepProspectRequest"
            @refresh-repair-file="handleProspectRefreshRepairFile"
            @save-and-close-repair-file="handleSaveAndCloseRepairFile"
          />
        </v-col>
      </v-row>
    </div>
    <!--END SUB_STEP_PROSPECT_REQUEST-->

    <!--SUB_STEP_PROSPECT_RESPONSE-->
    <div v-if="prospectRequestSent()">
      <v-divider class="mt-2" :thickness="2" />
      <v-row>
        <v-col class="pb-0">
          <h1 class="information-content-title mb-2 d-flex justify-space-between">
            {{ $t('STEP_PROSPECT.SUB_STEP_PROSPECT_RESPONSE.TITLE') }}
            <img
              v-if="prospectResponseValidated()"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <SubStepProspectResponse
            v-if="!prospectResponseValidated()"
            :currentRepairFile="currentRepairFile"
            ref="subStepProspectResponse"
            @go-to-next-step="goToTransportStep"
          />
        </v-col>
      </v-row>
    </div>
    <!--END SUB_STEP_PROSPECT_RESPONSE-->
  </v-card>
</template>

<style scoped>
.v-card {
  padding: 40px !important;
}

.information-content-title {
  margin-top: 40px;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.svg-check-rounded {
  width: 18px;
  height: 18px;
}
</style>
